var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59327 1.22947L0.583008 5.24415V8.74025C0.583008 9.04933 0.705787 9.34574 0.924336 9.56429C1.14288 9.78284 1.4393 9.90562 1.74837 9.90562H11.0713C11.3804 9.90562 11.6768 9.78284 11.8953 9.56429C12.1139 9.34574 12.2367 9.04933 12.2367 8.74025V5.24415L10.2264 1.22947C10.1299 1.03531 9.98121 0.871914 9.79695 0.757655C9.6127 0.643396 9.40022 0.582802 9.18341 0.582687H3.63627C3.41946 0.582802 3.20698 0.643396 3.02273 0.757655C2.83847 0.871914 2.68974 1.03531 2.59327 1.22947Z",
    stroke: "#10B981",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/Memory.7011a6da375b9b000e1f0cd91a2e9f53.svg";
export { ForwardRef as ReactComponent };